module.exports = __webpack_public_path__ + "assets/img/rolearms-f20782c4.png";